import React, { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { apiRoute, ENUM_INTCAL_OPTION, funValidateNoInput, INTEREST_CALBILL_TYPE, linksUrl, } from "../../constants/enum.js"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks.jsx"
import { addDaysToDate, calculateDaysBetween, calculateTotal, convertDate, exportInterestReportToPDF, funFormateDate, fungetdateyymmdd } from "../../Utility/utility.js"
import { ErrorCard, LoadingCard, MainContainer, NextUITable } from "../../components/index.js"
import { COLUMN_ALIGN_TYPE, COLUMN_TYPE, FOOTER_TYPE } from "../../components/NextUITable.jsx"
import { Input, CardBody, Card, Button, Chip, Select, SelectItem, Autocomplete, AutocompleteItem, Checkbox } from "@nextui-org/react"
import { faDownload, faRefresh, faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { isMobile } from "react-device-detect"
import { toast } from "react-toastify"
import { addDays } from "date-fns"

const InresetCalculation = () => {
  const navigate = useNavigate()
  const ENUM_SHOWBILL = {
    Outstanding: "Outstanding",
    Paid: "Paid",
    All: ""
  }
  const { compCode, compName, startDate, endDate, isMultipleCompany } = useSelector((state) => state.company)
  const [interestRate, setInterestRate] = useState(0);
  const [selectedBalAmount, setSelectedBalAmount] = useState(0);
  const [selectedIntAmount, setSelectedIntAmount] = useState(0);
  const [selectedKey, setSelectedKey] = useState(new Set());
  const [data, setData] = useState([]);
  const [diffDueDate, setDiffDueDate] = useState(new Date());
  const [selInvoiceNo, setSelInvoiceNo] = useState("");
  const [daysCalc, setDaysCalc] = useState("365");
  const [selChqNo, setSelChqNo] = useState("");
  const [isOverDueBills, setIsOverDueBills] = useState(false);
  const [isExcludePaymentDate, setIsExcludePaymentDate] = useState(false);
  const [selectedParty, setSelectedParty] = useState("")
  const [dueDays, setDueDays] = useState("");
  const [selShowBill, setSelShowBill] = useState(ENUM_SHOWBILL.All)
  const [selCalIntOption, setSelCalIntOption] = useState(ENUM_INTCAL_OPTION.WithOutGst)
  const { billid } = useParams();
  const [selBillType, setSelBillType] = useState("")
  const [reportLabel, setReportLabel] = useState("")
  const [removedBill, setRemovedBill] = useState([])

  const [invFilterDate, setInvFilterDate] = useState({
    start: startDate && startDate != "" && startDate != null ? startDate : null,
    end: endDate && endDate != "" && endDate != null ? endDate : null
  })
  const [payFilterDate, setPayFilterDate] = useState({
    start: null,
    end: null
  })


  const onSuccessData = (data) => {
    const newData = funManipulateData(data)
    setSelectedKey(new Set())
    setData(newData)
  }
  const isValidDate = (value) => {
    const date = new Date(value);
    return date instanceof Date && !isNaN(date);
  };

  const funManipulateData = (data) => {
    if (data && data.length > 0) {
      let BalIntDay = 0
      let isFullBal = 0;
      let totPaidAmt = 0;
      const newData = data.map((ele, index) => {
        let newBalAmt = 0
        let PayAmount = 0
        let t_payDate = dayjs(ele.PayDate).isValid() ? funFormateDate(ele.PayDate) : ""

        BalIntDay = ele.IntDays

        if (isCalIntWithGst()) {
          PayAmount = ele.PaidAmtRs

          if (ele.PayAmt <= 0) { //oustanding entry
            newBalAmt = parseFloat(ele.NetAmtRs) - parseFloat(ele.GR_Amt) - parseFloat(ele.GR_TaxAmt)
          }
          else { //paid entry
            if (ele.PaySrno <= 1)
              totPaidAmt = PayAmount
            else
              totPaidAmt += parseFloat(PayAmount)

            if (data.length - 1 > index) {
              if (data[index + 1].PaySrno <= 1) {
                newBalAmt = Math.round(parseFloat(ele.NetAmtRs) - parseFloat(ele.GR_Amt) - parseFloat(ele.GR_TaxAmt)) - parseFloat(totPaidAmt)
              }
              else
                newBalAmt = 0
            }
            else
              newBalAmt = Math.round(parseFloat(ele.NetAmtRs) - parseFloat(ele.GR_Amt) - parseFloat(ele.GR_TaxAmt)) - parseFloat(totPaidAmt)

          }
        }
        else {
          PayAmount = ele.PaidTaxableAmtRs
          if (ele.PayAmt <= 0) { //oustanding entry
            newBalAmt = parseFloat(ele.Taxable_Value) - parseFloat(ele.GR_Amt);
          }
          else { //paid entry
            if (ele.PaySrno <= 1)
              totPaidAmt = PayAmount
            else
              totPaidAmt += parseFloat(PayAmount)

            if (data.length - 1 > index) {

              if (data[index + 1].PaySrno <= 1) {
                newBalAmt = Math.round(parseFloat(ele.Taxable_Value) - parseFloat(ele.GR_Amt) - parseFloat(ele.GR_TaxAmt)) - parseFloat(totPaidAmt);
              }
              else
                newBalAmt = 0;
            }
            else
              newBalAmt = Math.round(parseFloat(ele.Taxable_Value) - parseFloat(ele.GR_Amt) - parseFloat(ele.GR_TaxAmt)) - parseFloat(totPaidAmt);
          }
        }
        if (newBalAmt == 0)
          BalIntDay = 0
        if (ele.PaySrno <= 1)

          return {
            ...ele, PayDate: t_payDate, BalAmount: newBalAmt.toFixed(0), TotalAmount: newBalAmt.toFixed(0), SrcPayAmount: PayAmount, IntDays: BalIntDay, SrcPaidIntDays: ele.PaidIntDays
            , OverDays: newBalAmt > 0 ? ele.OverDays : 0
          }
        else
          return { //multiple part payment entry
            ...ele, PayDate: t_payDate, BalAmount: newBalAmt.toFixed(0), TotalAmount: newBalAmt.toFixed(0), SrcPayAmount: PayAmount, SrcPaidIntDays: ele.PaidIntDays
            , Amount: 0, Discount: 0, Taxable_Value: 0, TaxAmt: 0, NetAmtRs: 0, IntDays: BalIntDay, DueDays: 0,
            OverDays: newBalAmt > 0 ? ele.OverDays : 0
            // / 
          }

      })
      return newData
    }
    else return []

  }
  const {
    isPending,
    isError,
    data: partyDetail = [],
    mutate: filterData

  } = usePost({
    url: apiRoute.outstanding.partyBills,
    queryKey: "OutstandingIntesetCalc" + selShowBill + billid,
    onSuccessTasks: onSuccessData
  })

  const {
    isPending: isPendingParty,
    isError: isErrorParty,
    data: partySummary = [],
    mutate: filterParty
  } = usePost({
    url: apiRoute.outstanding.masterData,
    queryKey: "OutstandingPartyMasterData",

  })


  const funloadData = () => {

    filterData({
      data: {
        compcode: compCode.join(","),
        bill_type: selBillType,
        party_id: selectedParty,
        chq_no: selChqNo && selChqNo != "" && selChqNo != null ? selChqNo : null,
        inv_no: selInvoiceNo && selInvoiceNo != "" && selInvoiceNo != null ? selInvoiceNo : null,
        over_duebill: isOverDueBills ? 1 : 0,
        showbill_type: selShowBill,
        inv_fromdate: funChkValidDate(invFilterDate.start) ? new Date(invFilterDate.start).toISOString().split("T")[0] : null,
        inv_todate: funChkValidDate(invFilterDate.end) ? new Date(invFilterDate.end).toISOString().split("T")[0] : null,
        diff_duedate: funChkValidDate(diffDueDate) ?
          new Date(diffDueDate).toISOString().split("T")[0] : new Date().toISOString().split("T")[0],
        pay_fromdate: funChkValidDate(payFilterDate.start) ? payFilterDate.start : null,
        pay_todate: funChkValidDate(payFilterDate.end) ? payFilterDate.end : null,

      }
    })
  }


  useEffect(() => {
    const params = [INTEREST_CALBILL_TYPE.Sale, INTEREST_CALBILL_TYPE.Purchase]
    if (!params.includes(String(billid)))
      navigate(linksUrl.dashboard.tradingDashboard)
    if (billid && billid != "") {
      let t_billType = ''
      let t_billid = billid.toLowerCase()
      if (t_billid == INTEREST_CALBILL_TYPE.Sale.toLowerCase()) {
        t_billType = 'S'
        setReportLabel("Sale Bill")
      }
      else if (t_billid == INTEREST_CALBILL_TYPE.Purchase.toLowerCase()) {
        t_billType = 'P'
        setReportLabel("Purchase Bill")
      }
      setSelBillType(t_billType)
      filterParty({
        data: {
          compcode: compCode.join(","),
          out_type: t_billType,
        }
      })
      setData([])
      setSelectedParty("")
    }

  }, [billid])


  // const keys = ['Discount', 'Taxable_Value', 'GR_Amt', 'TotalAmount', 'Amount', 'TaxAmt', 'NetAmtRs', 'GR_TaxAmt', 'PaidAmtRs']
  // const sumByKey = keys.reduce((acc, key) => {
  //   acc[key] = data.reduce((sum, obj) => sum + obj[key], 0);
  //   return acc;
  // }, {});
  const totalAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Amount",
      }),
    [data]
  )

  const totalDiscAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Discount",
      }),
    [data]
  )

  const totalTaxableAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "Taxable_Value",
      }),
    [data]
  )

  const totalTaxAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TaxAmt",
      }),
    [data]
  )

  const totalNetAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "NetAmtRs",
      }),
    [data]
  )

  const totalGrAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "GR_Amt",
      }),
    [data]
  )

  const totalGrTaxAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "GR_TaxAmt",
      }),
    [data]
  )

  const totalPaidAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "SrcPayAmount",
      }),
    [data]
  )

  const totalBalAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "BalAmount",
      }),
    [data]
  )

  const totalIntAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "IntAmount",
      }),
    [data]
  )

  const totalTotalAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TotalAmount",
      }),
    [data]
  )

  const totalTotalIntAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "TotalIntAmount",
      }),
    [data]
  )

  const totalPaidIntAmount = useMemo(
    () =>
      calculateTotal({
        data: data,
        columnName: "PaidIntAmount",
      }),
    [data]
  )

  let downloadDataFooter = {

    Bill_No: "Total",
    Bill_Date: "",
    Amount: totalAmount,
    Discount: totalDiscAmount,
    Taxable_Value: totalTaxableAmount,
    TaxAmt: totalTaxAmount,
    NetAmtRs: totalNetAmount,
    GR_Amt: totalGrAmount,
    GR_TaxAmt: totalGrTaxAmount,
    DueDays: "",
    DueDate: "",
    OverDays: "",
    PayDate: "",
    SrcPayAmount: totalPaidAmount,
    BalAmount: totalBalAmount,
    PaidIntPerDay: "",
    PaidIntDays: "",
    PaidIntAmount: totalPaidIntAmount,
    IntPerDay: "",
    IntDays: "",
    IntAmount: totalIntAmount,
    TotalAmount: totalTotalAmount,

  }

  const exportColumns = [
    {
      name: "INV NO",
      uid: "Bill_No",
    },
    {
      name: "INV DATE",
      uid: "Bill_Date",
      type: COLUMN_TYPE.date,
    },
    {
      name: "TAXABLE AMT",
      uid: "Taxable_Value",
      type: COLUMN_TYPE.number,
    },
    {
      name: "NET AMT",
      uid: "NetAmtRs",
      type: COLUMN_TYPE.number,
    },
    {
      name: "GR AMT",
      uid: "GR_Amt",
      type: COLUMN_TYPE.number,
    },
    {
      name: "GR TAX AMT",
      uid: "GR_TaxAmt",
      type: COLUMN_TYPE.number,
    },

    {
      name: "DUE DAYS",
      uid: "DueDays",
    },
    {
      name: "DUE DATE",
      uid: "DueDate",
      type: COLUMN_TYPE.date,
    },
    {
      name: "OVER DAYS",
      uid: "OverDays",
    },
    {
      name: "PAY DATE",
      uid: "PayDate",
      //  type: COLUMN_TYPE.date,
    },
    {
      name: "PAY AMT",
      uid: "SrcPayAmount",
      type: COLUMN_TYPE.number,
    },
    {
      name: "BAL AMT",
      uid: "BalAmount",
      type: COLUMN_TYPE.number,
    },
    {
      name: "INT/DAY PAID",
      uid: "PaidIntPerDay",
      type: COLUMN_TYPE.number,
    },
    {
      name: "INT DAYS PAID",
      uid: "PaidIntDays",
    },

    {
      name: "INT AMT PAID",
      uid: "PaidIntAmount",
      type: COLUMN_TYPE.number,
    },

    {
      name: "INT/DAY BAL",
      uid: "IntPerDay",
      type: COLUMN_TYPE.number,
    },
    {
      name: "INT DAYS BAL",
      uid: "IntDays",
    },

    {
      name: "INT AMT BAL",
      uid: "IntAmount",
      type: COLUMN_TYPE.number,
    },
    {
      name: "TOTAL AMT",
      uid: "TotalAmount",
      type: COLUMN_TYPE.number,
    },
    // {
    //   name: "COMPANY",
    //   align: COLUMN_ALIGN_TYPE.center,
    //   uid: "compname",
    //   sortable: true,
    // },
  ]

  const fun_RemoveSelection = (selectedBill) => {
    let d = selectedKey.filter(x => selectedBill.indexOf(x) === -1)
    const currentDataIndex = data.findIndex((ele) => ele.RowId == d[0]);
    if (currentDataIndex >= 0) {
      const updatedData = { ...data[currentDataIndex], IntAmount: 0, IntPerDay: 0, IntDays: data[currentDataIndex].OverDays, TotalAmount: data[currentDataIndex].BalAmount };
      const newData = [...data];
      newData[currentDataIndex] = updatedData
      setData(newData)
    }
  }

  // const fun_RemoveSelection = (selectedBill) => {
  //   //const selectedSet = new Set(selectedBill.map(Number));
  //   const allIdsNum = selectedKey.map(Number);
  //   const selectedSet = new Set(selectedBill.map(Number));
  //   const missing = allIdsNum.filter(id =>
  //     id >= Math.min(...selectedBill) &&
  //     id <= Math.max(...selectedBill) &&
  //     !selectedSet.has(id)
  //   );
  //   console.log(missing)
  //   setRemovedBill(missing)
  //   setSelectedKey(prev =>
  //     prev.filter(id => !missing.includes(id))
  //   );
  //   // setSelectedKey(prev => {
  //   //   const prevSet = new Set(prev);

  //   //   // 1. ADD everything from new selection
  //   //   selectedSet.forEach(id => {
  //   //     prevSet.add(id);
  //   //   });

  //   //   // 2. REMOVE only those that are NOT in new selection BUT exist in current page
  //   //   const currentPageIds = data.map(d => d.RowId);

  //   //   currentPageIds.forEach(id => {
  //   //     if (!selectedSet.has(id)) {
  //   //       prevSet.delete(id); // remove ONLY unselected (like 49, 46)
  //   //     }
  //   //   });

  //   //   return Array.from(prevSet);
  //   // });
  // }
  
  useEffect(() => {
    if (isMultipleCompany)
      navigate(linksUrl.dashboard.tradingDashboard)
  }, [])

  const fun_SetnterestDays = () => {

    if (selectedKey && selectedKey.size > 0) {
      let new_DueDays = ""

      let tempData;
      selectedKey.forEach(element => {
        // IntPerDay: int_PerDay, IntAmount: cal_Interest.toFixed(2), IntDays: t_IntDays
        let currentItemIndex = data.findIndex((args, i) => args.RowId == element);

        let newData;
        if (dueDays && dueDays != null && dueDays != "" && dueDays != "0")
          new_DueDays = dueDays
        else
          new_DueDays = data[currentItemIndex].SrcDueDays

        const updatedData = { ...data[currentItemIndex], DueDays: new_DueDays };
        if (tempData)
          newData = [...tempData]
        else
          newData = [...data];
        newData[currentItemIndex] = updatedData;
        setData(newData)
        tempData = newData;

      });
    }
    if (!dueDays || dueDays == null || dueDays == "" || dueDays == "0") {
      fun_CalBalnInterest()
    }

  }

  useEffect(() => {
    fun_SetnterestDays();
  }, [dueDays])

  const isCalIntWithGst = () => {
    if (selCalIntOption == ENUM_INTCAL_OPTION.WithGst)
      return true
    else
      return false
  }

  const convertDateFns = (dateStr) => {
    const parsed = dayjs(dateStr, 'DD/MM/YYYY');
    return parsed.isValid() ? parsed.format('YYYY-MM-DD') : 'Invalid date';
  };
  const fun_CalBalnInterest = () => {
    let total_selectedBal = 0;
    let total_selectedInt = 0;
    let total_selectedPaid = 0;
    let paid_total_selectedInt = 0;


    const billData = funManipulateData(partyDetail);
    if (selectedKey && selectedKey.size > 0) {
      let tempData;
      let new_DueDays = "";
      let intSrcColumn = "BalAmount"

      selectedKey.forEach(element => {

        let filterData = billData.filter((args, i) => args.RowId == element);

        if (filterData.length > 0) {
          total_selectedBal += parseFloat(filterData[0][intSrcColumn]);
          total_selectedPaid += parseFloat(filterData[0]["SrcPayAmount"])
          setSelectedBalAmount((parseFloat(total_selectedBal) + parseFloat(total_selectedPaid)).toFixed(2))

          new_DueDays = filterData[0].SrcDueDays;

          if (dueDays != null && dueDays && dueDays != "" && dueDays != "0")
            new_DueDays = Number(dueDays)

          let cal_Interest = 0
          let int_PerDay = 0
          let paid_Int_PerDay = 0
          let paid_Cal_Interest = 0
          let diffDueDays = 0;
          let new_OverDays = filterData[0].OverDays
          let new_DueDate = filterData[0].DueDate
          let new_PaidIntDays = filterData[0].SrcPaidIntDays
          if (new_DueDays > 0) {
            diffDueDays = parseFloat(filterData[0].SrcDueDays) - parseFloat(new_DueDays)
            new_OverDays = parseFloat(filterData[0].OverDays) + parseFloat(diffDueDays)

            if (addDaysToDate(filterData[0]["DueDate"], diffDueDays) != "Invalid Date") {
              let Date_Day = diffDueDays
              if (diffDueDays <= 0)
                Date_Day = Math.abs(diffDueDays)
              else
                Date_Day = Number(diffDueDays) * -1

              new_DueDate = dayjs(filterData[0]["DueDate"]).add(Date_Day, 'day').format('YYYY-MM-DD');
              if (filterData[0].PayDate != "") {
                //console.log(filterData[0].PayDate,"c")
                const payDate = convertDateFns(filterData[0].PayDate)
                const start = dayjs(new_DueDate);
                const end = dayjs(payDate)
                // if (!start.isValid() || !end.isValid())
                if (isExcludePaymentDate) {
                  new_PaidIntDays = (end.diff(start, 'day') - 1);
                }
                else

                  new_PaidIntDays = end.diff(start, 'day');
              }
              else
                new_PaidIntDays = 0

              // new_DueDate = addDaysToDate(filterData[0]["DueDate"], Date_Day)
              // new_PaidIntDays = calculateDaysBetween(newDate, filterData[0].PayDate);
            }
          }

          let t_daysCalc = daysCalc && daysCalc != "" && daysCalc != null ? daysCalc : 365
          if (interestRate > 0) {

            int_PerDay = ((parseFloat(filterData[0][intSrcColumn]) * interestRate) / 100 / parseFloat(t_daysCalc)).toFixed(2)
            cal_Interest = Math.round(parseFloat(int_PerDay) * parseFloat(new_OverDays))
            total_selectedInt += parseFloat(cal_Interest)

            if (parseFloat(filterData[0]["PayAmt"]) > 0) {

              paid_Int_PerDay = ((parseFloat(filterData[0]["SrcPayAmount"]) * interestRate) / 100 / parseFloat(t_daysCalc)).toFixed(2)
              // paid_Cal_Interest = Math.round(parseFloat(paid_Int_PerDay) * parseFloat(filterData[0]["PaidIntDays"]))
              // paid_total_selectedInt += parseFloat(paid_Cal_Interest)
              paid_Cal_Interest = Math.round(parseFloat(paid_Int_PerDay) * parseFloat(new_PaidIntDays))
              paid_total_selectedInt += parseFloat(paid_Cal_Interest)

            }
          }

          setSelectedIntAmount((parseFloat(total_selectedInt) + parseFloat(paid_total_selectedInt)).toFixed(2))
          const currentItemIndex = billData.findIndex((ele) => ele.RowId == element);
          let newData;
          const updatedData = {
            ...billData[currentItemIndex],
            IntPerDay: int_PerDay, IntAmount: cal_Interest, IntDays: new_OverDays,
            OverDays: new_OverDays, DueDays: new_DueDays, DueDate: new_DueDate,
            PaidIntPerDay: paid_Int_PerDay, PaidIntAmount: paid_Cal_Interest,
            TotalAmount: Math.round(parseFloat(filterData[0].BalAmount) + parseFloat(cal_Interest) + parseFloat(paid_Cal_Interest)),
            TotalIntAmount: Math.round(parseFloat(cal_Interest) + parseFloat(paid_Cal_Interest)),
            PaidIntDays: new_PaidIntDays,



          };
          if (tempData)
            newData = [...tempData]
          else
            newData = [...billData];
          newData[currentItemIndex] = updatedData;
          setData(newData)
          tempData = newData;
        }
      });
    }
    else {
      setSelectedBalAmount(0)
      setSelectedIntAmount(0)
      setData(funManipulateData(partyDetail))

    }

  }


  const handleCheckSelection = useCallback((event) => {

    const { column, e } = event;


    if (e == "all") {

      let arrayAll = []

      data.forEach(ele => {
        arrayAll.push(ele.RowId)
      });
      setSelectedKey(arrayAll)
      //console.log(arrayAll,e,"gh")
    }
    else {
      let selectedBill = Array.from(e);
      // console.log(e)
      let keyList = selectedBill.map(Number)
      // console.log(selectedBill,e,selectedKey,keyList)
      if (selectedKey) {
        fun_RemoveSelection(keyList);
      }

      //setSelectedKey(keyList);
    }
  }, [selectedKey, data])


  const currentPageIds = useMemo(() => {
    return data.map((row) => String(row.RowId));
  }, [data]);

  const INITIAL_VISIBLE_COLUMNS = [
    "Bill_No",
    "Bill_Date",
    "Amount",
    "Discount",
    "Taxable_Value",
    "TaxAmt",
    "NetAmtRs",
    "GR_Amt",
    "GR_TaxAmt",
    "DueDays",
    "DueDate",
    "OverDays",
    "PayDate",
    "SrcPayAmount",
    "BalAmount",
    "PaidIntPerDay",
    "PaidIntDays",
    "PaidIntAmount",
    "IntPerDay",
    "IntDays",
    "IntAmount",
    "TotalIntAmount",
    "TotalAmount",

  ]

  const columns = [
    {
      name: "INV NO",
      uid: "Bill_No",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "INV DATE",
      uid: "Bill_Date",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Amount",
      uid: "Amount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalAmount,
      },
    },

    {
      name: "Discount",
      uid: "Discount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalDiscAmount,
      },
    },
    {
      name: "Taxable Amt",
      uid: "Taxable_Value",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTaxableAmount,
      },
    },
    {
      name: "Tax Amt",
      uid: "TaxAmt",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTaxAmount,
      },
    },
    {
      name: "Net Amt",
      uid: "NetAmtRs",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalNetAmount,
      },
    },
    {
      name: "GR Amt",
      uid: "GR_Amt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalGrAmount,
      },
    },
    {
      name: "GR tax Amt",
      uid: "GR_TaxAmt",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
      type: COLUMN_TYPE.number,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalGrTaxAmount,
      },
    },

    {
      name: "Due Days",
      uid: "DueDays",
      align: COLUMN_ALIGN_TYPE.center,

      sortable: true,
    },
    {
      name: "DUE Date",
      uid: "DueDate",
      type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Over Days",
      uid: "OverDays",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Pay Date",
      uid: "PayDate",
      // type: COLUMN_TYPE.date,
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Pay Amt",
      uid: "SrcPayAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPaidAmount,
      },
    },
    {
      name: "Bal Amt",
      uid: "BalAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalBalAmount,
      },
    },
    {
      name: "Int/Day PAID",
      uid: "PaidIntPerDay",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Int Days Paid",
      uid: "PaidIntDays",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "IntAmt PAID",
      uid: "PaidIntAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalPaidIntAmount,
      },
    },
    {
      name: "Int/Day BAL",
      uid: "IntPerDay",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Int Days Bal",
      uid: "IntDays",
      align: COLUMN_ALIGN_TYPE.center,
      sortable: true,
    },
    {
      name: "Int Amt BAL",
      uid: "IntAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalIntAmount,
      },
    },

    {
      name: "Total Int Amt",
      uid: "TotalIntAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTotalIntAmount,
      },
    },

    {
      name: "Total Amt",
      uid: "TotalAmount",
      align: COLUMN_ALIGN_TYPE.center,
      type: COLUMN_TYPE.number,
      sortable: true,
      footer: {
        type: FOOTER_TYPE.text,
        label: "Total: ",
        value: totalTotalAmount,
      },
    },
    // {
    //   name: "COMPANY",
    //   align: COLUMN_ALIGN_TYPE.center,
    //   uid: "compname",
    //   sortable: true,
    // },
  ]

  const PaidColumn = ['PayDate', 'SrcPayAmount', 'PaidIntAmount', 'PaidIntPerDay', 'PaidIntDays', 'TotalIntAmount']
  const filtereColumn = useMemo(() => {
    if (selShowBill == ENUM_SHOWBILL.Outstanding) //PaidTaxableAmtRs
      return columns.filter((ele) => !PaidColumn.includes(ele.uid))
    else {
      return columns

    }
  }, [selShowBill, data, selCalIntOption])


  const filtereInitial = useMemo(() => {
    if (selShowBill == ENUM_SHOWBILL.Outstanding)
      return INITIAL_VISIBLE_COLUMNS.filter((ele) => !PaidColumn.includes(ele))
    else {
      return INITIAL_VISIBLE_COLUMNS
    }
  }, [selShowBill, data])

  //console.log(filtereColumn, filtereInitial)
  const {
    isPending: isAddressPending,
    data: addressData = [],
    mutate: funGetPartyAdd
  } = usePost({
    url: apiRoute.outstanding.partyInfo,
    queryKey: "OutstandingPartySummary-Address",

  })

  const currentParty = useMemo(() => {
    let partyName = ""
    if (selectedParty && selectedParty != "" && selectedParty != null) {
      if (partySummary && partySummary.length > 0) {
        const data = partySummary.filter((ele) => ele.Party_Id == selectedParty)
        if (data && data.length > 0)
          partyName = data[0].Party_Name
      }
    }
    return partyName
  }, [selectedParty])

  useEffect(() => {
    fun_CalBalnInterest();
  }, [selectedKey, interestRate, selCalIntOption, dueDays, daysCalc, isExcludePaymentDate])


  const addReportDataFooter = (tempData) => {
    let downloadReportFooter = {}
    if (Object.keys(downloadReportFooter).length > 0) {
      return [...tempData, downloadReportFooter]
    }
    return tempData
  }

  const downloadBillDetail = [
    { key: "Interest", value: interestRate + " % " },
    { key: isCalIntWithGst() ? "Balance Amount" : "Taxable Amount", value: selectedBalAmount },
    { key: "Interest Amount", value: selectedIntAmount },

  ]
  const funChkValidDate = (date) => {
    if (date != null && date != "" && date != "Invalid Date")
      return 1
    else
      return 0
  }

  const funGetReportTitle = () => {
    let title = `Interest Calculation Report{${isCalIntWithGst() ? "On Net Amount(With GST)" : "On Taxable Amount (Without Gst)"}}`
    if (selShowBill == ENUM_SHOWBILL.Paid) {
      title = `Bill To Bill Interest Calculation Report{${isCalIntWithGst() ? "On Net Amount(With GST)" : "On Taxable Amount (Without Gst)"}} For Invoice Period: ${funChkValidDate(invFilterDate.start) ? convertDate(new Date(invFilterDate.start).toISOString().split("T")[0]) : ""} - ${funChkValidDate(invFilterDate.end) ? convertDate(new Date(invFilterDate.end).toISOString().split("T")[0]) : ""}`
    }
    else if (selShowBill == ENUM_SHOWBILL.Outstanding) {
      title = `${selBillType == "S" ? "Receivable" : selBillType == "P" ? "Payable" : ""} Outstanding Up To : ${funChkValidDate(endDate) ? convertDate(new Date(endDate).toISOString().split("T")[0]) : ""}   Run Date : ${(new Date()).toLocaleString('en-GB', { hour12: true })}`
    }
    return title

  }

  const funCalReportTotal = (filterData) => {
    // let totalAmount = 0;
    // let totalDiscAmount = 0;
    let totalTaxableAmount = 0;
    let totalNetAmount = 0;
    let totalGrAmount = 0;
    let totalGrTaxAmount = 0;
    let totalPaidAmount = 0;
    let totalIntAmount = 0;
    let totalTotalAmount = 0;
    let totalBalAmount = 0;
    let totalPaidIntAmount = 0;

    filterData.map((ele) => {

      // totalAmount += ele.Amount;
      // totalDiscAmount += ele.Discount;
      totalTaxableAmount += parseFloat(ele.Taxable_Value);
      // totalTaxAmount += ele.TaxAmt;
      totalNetAmount += parseFloat(ele.NetAmtRs);
      totalGrAmount += parseFloat(ele.GR_Amt);
      totalGrTaxAmount += parseFloat(ele.GR_TaxAmt);
      totalPaidAmount += parseFloat(ele.SrcPayAmount);
      totalIntAmount += parseFloat(ele.IntAmount);
      totalTotalAmount += parseFloat(ele.TotalAmount);
      totalBalAmount += parseFloat(ele.BalAmount)
      totalPaidIntAmount += parseFloat(ele.PaidIntAmount)
    })

    downloadDataFooter = {
      ...downloadDataFooter,
      //Amount: totalAmount,
      //Discount: totalDiscAmount,
      Taxable_Value: totalTaxableAmount,
      // TaxAmt: totalTaxAmount,
      NetAmtRs: totalNetAmount,
      GR_Amt: totalGrAmount.toFixed(2),
      GR_TaxAmt: totalGrTaxAmount.toFixed(2),
      SrcPayAmount: totalPaidAmount,
      BalAmount: totalBalAmount.toFixed(0),
      IntAmount: totalIntAmount.toFixed(0),
      TotalAmount: totalTotalAmount.toFixed(0),
      PaidIntAmount: totalPaidIntAmount.toFixed(0)
    }

  }


  const keysToKeep = selShowBill == ENUM_SHOWBILL.Outstanding ? ['Discount', 'TaxAmt', 'PayDate', 'SrcPayAmount', 'Amount', 'PaidIntAmount', 'PaidIntDays', 'PaidIntPerDay'] : ['Discount', 'TaxAmt', 'Amount'];

  const handleExportReport = () => {
    if (selectedKey && selectedKey.size > 0) {
      if (interestRate && interestRate != null && interestRate != "" && interestRate != "0") {
        let filterData = [];
       const keyList = Array.from(selectedKey).map(String);
        
        if (interestRate > 0)
          filterData = data.filter((ele) => keyList.includes(ele.RowId));
        else
          filterData = data;

        funCalReportTotal(filterData);

        exportInterestReportToPDF({
          data: addReportDataFooter(filterData),
          billType: selShowBill,
          downloadFileName: `${reportLabel}_Interest_Report`,
          reportTitle: funGetReportTitle(),
          downloadDataFooter: isMultipleCompany ? downloadDataFooter : Object.fromEntries(
            Object.entries(downloadDataFooter).filter(([key, value]) => !keysToKeep.includes(key))
          ),
          downloadBillDetail: downloadBillDetail,
          exportColumns: exportColumns.filter((ele) => !keysToKeep.includes(ele.uid)),
          downloadFileheader: {
            "party": currentParty, "company": compName,
            "address": addressData && addressData.length > 0 ? addressData[0]?.Party_Address : "",
            "broker": ""
          },
        })
      }
      else {
        toast.error("Enter Interest Rate", {
          "position": "top-center"
        })
      }
    }
    else {
      toast.error("Select Bills", {
        "position": "top-center"
      })
    }
  }
  const handlePartyChange = (val) => {
    setSelectedParty(val)
    funGetPartyAdd({
      data: {
        compcode: compCode.join(","),
        party_id: val,
      }
    })
  }
  const handleResetData = () => {
    setSelShowBill("")
    setInvFilterDate({
      start: startDate && startDate != "" && startDate != null ? startDate : null,
      end: endDate && endDate != "" && endDate != null ? endDate : null
    })
    setPayFilterDate({ start: null, end: null })
    setSelChqNo("")
    setSelInvoiceNo("")
    setIsOverDueBills(false)
    setDiffDueDate(new Date())
    setDueDays(0)
    setInterestRate(0)
    setSelectedBalAmount(0)
    setIsExcludePaymentDate(false)
    setSelectedIntAmount(0)
    filterData({
      data: {
        compcode: compCode.join(","),
        bill_type: selBillType,
        party_id: selectedParty,
        chq_no: null,
        inv_no: null,
        over_duebill: 0,
        showbill_type: null,
        inv_fromdate: null,
        inv_todate: null,
        diff_duedate: new Date().toISOString().split("T")[0],
        pay_fromdate: null,
        pay_todate: null,

      }
    })
  }

  const handleFindData = () => {

    if (selectedParty && selectedParty != "" && selectedParty != null) {
      funloadData(diffDueDate);
    }
    else {
      toast.error("Select party !", {
        "position": "top-center"
      })
    }
  }
  const handleShowBillChange = (value) => {
    setSelShowBill(value)
    if (value == ENUM_SHOWBILL.Outstanding)
      setIsExcludePaymentDate(false)

  }
 const handleSelectionChange = (payload) => {
  

  const { e } = payload;

  // 🔥 CASE 1: Select all
  if (e === "all") {
    const allKeys = data.map((row) => row.RowId);
    setSelectedKey(new Set(allKeys));
    return;
  }

  // 🔥 CASE 2: empty selection
  if (!e) {
    setSelectedKey(new Set());
    return;
  }

  // 🔥 CASE 3: if Set
  if (e instanceof Set) {
    setSelectedKey(e);
    return;
  }

  // 🔥 CASE 4: array
  if (Array.isArray(e)) {
    setSelectedKey(new Set(e));
    return;
  }

  // 🔥 CASE 5: fallback (single value or object)
  if (typeof e === "string" || typeof e === "number") {
    setSelectedKey(new Set([e]));
    return;
  }

  console.warn("Unknown selection format:", e);

};
  if (isPending) {
    return <LoadingCard />
  }

  if (isError) {
    return <ErrorCard />
  }

  return (
    <div>
      <MainContainer
        pageName={`Interest Calculation - ${reportLabel}`}
        info={[
        ]}
        breadcrumbs={["Interest calculation ", `${reportLabel}`]}

      >

        <div className="border-0 ">

          <Card shadow="sm" radius="sm" className="mb-3 h-full">
            {/* <div className="p-2 bg-gradient-to-br from-stone-50 to-blue-200 text-xs text-slate-9 00 text-sm font-semibold">
              INTEREST CALCULATION
            </div> */}
            <CardBody className="p-2">
              <div className=" mb-2 pb-2 gap-2 items-center ">
                <div className={`flex w-full  ${isMobile ? "flex-wrap" : ""} gap-2 pb-2 items-center`}>
                  <Autocomplete
                    size={"sm"}
                    label={"Party Name"}
                    variant="flat"
                    color="danger"
                    className={`${isMobile ? "w-full" : "w-full"}  font-semibold`}
                    isVirtualized={true}
                    placeholder="party"
                    defaultItems={partySummary && partySummary.length > 0 ? partySummary : []}
                    onSelectionChange={handlePartyChange}
                    selectedKey={selectedParty}
                    classNames={{ label: "font-bold" }}
                    isLoading={isPendingParty}
                    popoverProps={{
                      placement: "bottom",
                      shouldFlip: false,
                      offset: 6,
                    }}

                    listboxProps={{
                      style: {
                        maxHeight: "200px",
                        overflowY: "auto",
                      },
                    }}
                  >
                    {
                      (items) => {
                        return (
                          <AutocompleteItem key={items.Party_Id} textValue={items.Party_Name}>
                            {items.Party_Name}
                          </AutocompleteItem>
                        )
                      }
                    }

                  </Autocomplete>
                  <div className="flex w-full gap-2 mt-2 item-center">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label={"Invoice From Date"}
                        views={["day", "month", "year"]}
                        format="DD/MM/YYYY"
                        labelPlacement="outside"
                        value={invFilterDate.start
                          ? dayjs(invFilterDate.start)
                          : invFilterDate.start}
                        onChange={(newValue) => {
                          setInvFilterDate((prev) => {
                            return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                          })
                        }}
                        className={`${isMobile ? "w-5/12" : "w-auto"}  font-semibold`}
                        slotProps={{ textField: { size: "small" } }}
                      />
                      <DatePicker
                        label={"Invoice To Date"}
                        views={["day", "month", "year"]}
                        format="DD/MM/YYYY"
                        value={invFilterDate.end
                          ? dayjs(invFilterDate.end)
                          : invFilterDate.end}
                        onChange={(newValue) => {
                          setInvFilterDate((prev) => {

                            return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                          })
                        }}
                        className={`${isMobile ? "w-5/12" : "w-auto"}  font-semibold`}
                        slotProps={{ textField: { size: "small" } }}
                      //sx={{ width: "145px" }}
                      />
                    </LocalizationProvider>

                    <Input
                      size="sm"
                      type="text"
                      color="warning"
                      label="Invoice No."
                      value={selInvoiceNo}
                      onChange={(e) => setSelInvoiceNo(e.target.value)}
                      className={`${isMobile ? "w-auto" : "max-w-40"}  font-semibold`}
                    ></Input>
                  </div>
                </div>
                <div className="flex flex-wrap gap-2 items-center">
                  <Select
                    className={`${isMobile ? "w-full" : "w-2/6"}  font-semibold`}
                    size="sm"
                    label={"Show Bills"}
                    color={"success"}
                    placeholder={""}
                    variant="flat"
                    onChange={(e) => handleShowBillChange(e.target.value)}
                    selectedKeys={[String(selShowBill)]}
                  >
                    <SelectItem key={ENUM_SHOWBILL.All}>All</SelectItem>
                    <SelectItem key={ENUM_SHOWBILL.Outstanding}>Outstanding</SelectItem>
                    <SelectItem key={ENUM_SHOWBILL.Paid}>Paid</SelectItem>
                  </Select>

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label={"Interest Up To Date"}
                      views={["day", "month", "year"]}
                      format="DD/MM/YYYY"
                      value={
                        diffDueDate
                          ? dayjs(diffDueDate)
                          : diffDueDate
                      }
                      onChange={(newValue) => {
                        setDiffDueDate(dayjs(newValue).format("YYYY-MM-DD"))
                      }}
                      className={`${isMobile ? "max-w-32" : "w-auto"}  font-semibold`}
                      slotProps={{ textField: { size: "small" } }}
                    />

                  </LocalizationProvider>
                  <Checkbox size="md"
                    classNames={{ label: "text-sky-700 text-sm" }}
                    isSelected={isOverDueBills} className="text-xs font-semibold" onValueChange={setIsOverDueBills} color="primary">Over Due Bills Only</Checkbox>
                  {
                    selShowBill && selShowBill == "Paid" ?
                      <div className="flex w-full gap-2 mt-2 item-center">


                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label={"Payment From Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            labelPlacement="outside"
                            value={payFilterDate.start
                              ? dayjs(payFilterDate.start)
                              : payFilterDate.start}
                            onChange={(newValue) => {
                              setPayFilterDate((prev) => {
                                return { ...prev, start: dayjs(newValue).format("YYYY-MM-DD") }
                              })
                            }}
                            className={`${isMobile ? "w-5/12" : "w-full"}  font-semibold`}
                            slotProps={{ textField: { size: "small" } }}

                          />
                          <DatePicker
                            label={"Payment To Date"}
                            views={["day", "month", "year"]}
                            format="DD/MM/YYYY"
                            value={payFilterDate.end
                              ? dayjs(payFilterDate.end)
                              : payFilterDate.end}
                            onChange={(newValue) => {
                              setPayFilterDate((prev) => {

                                return { ...prev, end: dayjs(newValue).format("YYYY-MM-DD") }
                              })
                            }}
                            className={`${isMobile ? "w-5/12" : "w-full"}  font-semibold`}
                            slotProps={{ textField: { size: "small" } }}
                          //sx={{ width: "145px" }}
                          />
                        </LocalizationProvider>
                        <Input
                          size="sm"
                          type="text"
                          color="warning"
                          label="Chq No."
                          value={selChqNo}
                          onChange={(e) => setSelChqNo(e.target.value)}
                          className="max-w-40 font-semibold"
                        ></Input>
                      </div> : ""}
                </div>
                <div className="text-center mt-2 gap-2 flex items-center  justify-center">
                  <Button onPress={handleFindData} color="primary" size="sm" className={`${isMobile ? "w-full" : "w-2/6"}  text-sm`}
                    startContent={<FontAwesomeIcon icon={faSearch} />} >Show</Button>
                  <Button onPress={handleResetData} color="warning" size="sm" className={`${isMobile ? "w-full" : "w-2/6"}  text-sm`}
                    startContent={<FontAwesomeIcon icon={faRefresh} />} >Reset</Button>
                </div>
              </div>
              <div className="flex   items-center mt-2 gap-2 alert alert-info">
                <Input
                  size="sm"
                  type="text"
                  color="danger"
                  label="Total.Amt"
                  labelPlacement="outside"
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-rose-600 text-sm">₹</span>
                    </div>
                  }
                  readOnly
                  value={selectedBalAmount}
                  onChange={(e) => setSelectedBalAmount(e.target.value)}
                  className="max-w-25 font-semibold"
                ></Input>
                <Input
                  size="sm"
                  type="text"
                  color="danger"
                  readOnly
                  label="Interest.Amt"
                  labelPlacement="outside"
                  startContent={
                    <div className="pointer-events-none flex items-center">
                      <span className="text-rose-600 text-sm">₹</span>
                    </div>
                  }
                  value={selectedIntAmount}
                  onChange={(e) => setSelectedIntAmount(e.target.value)}
                  className="max-w-25 font-semibold"
                ></Input>
              </div>
              <div className="flex flex-wrap  align-center  mt-2 items-end gap-2 alert alert-info">
                <Select
                  className={`${isMobile ? "w-1/2" : "max-w-36"}  font-semibold`}
                  size="sm"
                  label={`${isMobile ? "Int.Cal" : "Interest Calculation"}  `}
                  placeholder={""}
                  labelPlacement="outside"
                  variant="bordered"
                  color="danger"
                  onChange={(e) => setSelCalIntOption(e.target.value)}
                  selectedKeys={[String(selCalIntOption)]}
                >
                  <SelectItem key={ENUM_INTCAL_OPTION.WithOutGst}>Without Gst</SelectItem>
                  <SelectItem key={ENUM_INTCAL_OPTION.WithGst}>With Gst</SelectItem>
                </Select>
                <Input
                  size="sm"
                  type="number"
                  color="warning"
                  label="Days.Calc"
                  labelPlacement="outside"
                  value={daysCalc}
                  onChange={(e) => setDaysCalc(e.target.value)}
                  className={`${isMobile ? "w-2/5" : "max-w-24"}  font-semibold`}

                ></Input>
                <div className="flex  align-center  items-center gap-2 alert alert-info">

                  <Input type="number" size="sm"
                    label={`${isMobile ? "Int.(%)" : "Interest(%)"}  `}
                    variant="bordered"
                    color="danger"
                    className={`${isMobile ? "max-w-22" : "max-w-36"}  font-semibold`}
                    labelPlacement="outside"
                    endContent={
                      <div className="pointer-events-none flex items-center">
                        <span className="text-slate-600 text-sm">%</span>
                      </div>
                    }
                    value={interestRate}
                    onChange={(e) => setInterestRate(e.target.value)}
                  ></Input>
                  <Input
                    size="sm"
                    type="text"
                    color="danger"
                    variant="bordered"
                    label={"Due Days"}
                    labelPlacement="outside"
                    placeholder={" "}
                    value={dueDays}
                    onChange={(e) => funValidateNoInput(e.target.value) ? setDueDays(e.target.value) : setDueDays("")}
                    className={`${isMobile ? "max-w-22" : "max-w-36"}  font-semibold`}
                  ></Input>
                </div>
                <div className={`${isMobile ? " w-full" : "flex gap-2"}  `}>
                  {selShowBill == ENUM_SHOWBILL.Outstanding ? "" :
                    <div className="mb-2 text-center bg-rose-100 py-1 px-2">
                      <Checkbox size="md"
                        classNames={{ label: "text-sky-700 text-sm " }}
                        isSelected={isExcludePaymentDate} className="text-xs font-semibold" onValueChange={setIsExcludePaymentDate} color="primary">Exclude Payment Date</Checkbox>
                    </div>}
                  <Button onPress={handleExportReport} color="danger" size="sm" className={`${isMobile ? "w-full" : "max-w-36"}  text-sm`}
                    startContent={<FontAwesomeIcon icon={faDownload} />} >Report</Button>
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className=" overflow-y-hidden overflow-x-auto">
          <NextUITable
            INITIAL_VISIBLE_COLUMNS={filtereInitial}
            data={data}
            columns={filtereColumn}
            exportColumns={exportColumns}
            showAdvanceFilter={false}
            downloadDataFooter={downloadDataFooter}
            rowSelection={true}
            downloadFileName="Party_Bills_Detail"
            //handleSelectionChange
            //={handleCheckSelection}
             handleSelectionChange={handleSelectionChange}
            selectedKeys={selectedKey}
            setSelectedKeys={setSelectedKey}
            id="RowId"
          />
        </div>

      </MainContainer>
    </div>
  )
}

export default InresetCalculation
